/* Written by Ye Liu */

// Mapbox-GL library access token
const ACCESS_TOKEN = 'pk.eyJ1IjoiZ2Fydm94IiwiYSI6ImNseHZucnRpcDB4Y3EycXNkNjRuM3drNWsifQ.V5lH9roOpH9a6Jphwybprw';

export { ACCESS_TOKEN };
